export default __webpack_public_path__ + "images/f0ffb2659846c1e4410be62d3b48f888-kareem-white-icon.svg";